export default __webpack_public_path__ + "graphics/hyperlink-black.2bd6f4f3.svg";